import { Http } from "../Http";
import { AvailableAppointmentsApiResponse } from "@apiModels/AvailableAppointmentsApiResponse.csharp";
import { DetailedAppointmentsApiResponse } from "@apiModels/DetailedAppointmentsApiResponse.csharp";
import { InsuranceAppointmentsAvailabilityDto } from "@apiModels/InsuranceAppointmentsAvailabilityDto.csharp";
import { BookingCancellationDeadlineDto } from "@apiModels/BookingCancellationDeadlineDto.csharp";
import { formatISO9075 } from "date-fns";
import { ServicePricingSummary } from "../../Partials/PricingHighlight/ServicePricingSummary.csharp";

export class AppointmentsApi {
  public getAvailable = (
    serviceId: string,
    fromDate: string,
    toDate: string
  ): Promise<AvailableAppointmentsApiResponse> => {
    return Http.get(
      `/api/services/${encodeURIComponent(
        serviceId
      )}/appointments/summary?fromDate=${encodeURIComponent(
        fromDate
      )}&toDate=${encodeURIComponent(toDate)}`,
      null
    ) as Promise<AvailableAppointmentsApiResponse>;
  };
  public getAvailableWithSession = (
    serviceId: string,
    fromDate: string,
    toDate: string,
    bookingSessionId: string
  ): Promise<AvailableAppointmentsApiResponse> => {
    return Http.get(
      `/api/services/${encodeURIComponent(
        serviceId
      )}/appointments/summary?fromDate=${encodeURIComponent(
        fromDate
      )}&toDate=${encodeURIComponent(
        toDate
      )}&bookingSessionId=${encodeURIComponent(bookingSessionId)}`,
      null
    ) as Promise<AvailableAppointmentsApiResponse>;
  };

  public getDetails = (
    serviceId: string,
    date: string
  ): Promise<DetailedAppointmentsApiResponse> => {
    return Http.get(
      `/api/services/${encodeURIComponent(
        serviceId
      )}/appointments?date=${encodeURIComponent(date)}`,
      null
    ) as Promise<DetailedAppointmentsApiResponse>;
  };

  public getPricingSummary = (
    serviceVariantId: string,
    serviceId: string,
    centerId: string,
    startTime: Date
  ): Promise<ServicePricingSummary> => {
    return Http.get(
      `/api/services/appointments/pricing?serviceId=${encodeURIComponent(
        serviceId
      )}&serviceVariantId=${encodeURIComponent(
        serviceVariantId
      )}&centerId=${encodeURIComponent(centerId)}&startTime=${formatISO9075(
        startTime
      )}`,
      null
    ) as Promise<ServicePricingSummary>;
  };

  public getFirstAvailable = (
    serviceId: string
  ): Promise<InsuranceAppointmentsAvailabilityDto> => {
    return Http.get(
      `/api/services/${serviceId}/appointments/first-available`
    ) as Promise<InsuranceAppointmentsAvailabilityDto>;
  };

  public getCancellationDeadline = (
    serviceId: string,
    centerId: string,
    startTime: Date
  ): Promise<BookingCancellationDeadlineDto> => {
    return Http.get(
      `/api/booking-cancellation/get-deadline?serviceId=${encodeURIComponent(
        serviceId
      )}&centerId=${encodeURIComponent(
        centerId
      )}&startTime=${encodeURIComponent(formatISO9075(startTime))}`,
      null
    ) as Promise<BookingCancellationDeadlineDto>;
  };

  public getByDateRange = (
    serviceId: string,
    dateFrom: string,
    dateTo: string
  ): Promise<DetailedAppointmentsApiResponse> => {
    return Http.get(
      `/api/services/${encodeURIComponent(
        serviceId
      )}/appointments/date-range?fromDate=${encodeURIComponent(
        dateFrom
      )}&toDate=${encodeURIComponent(dateTo)}`,
      null
    ) as Promise<DetailedAppointmentsApiResponse>;
  };
}
